<template>
  <div id="processesWrapper">
    <ul>
      <process
        v-for="(process, idx) in processes"
        :key="idx"
        :process="process">
      </process>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Process from '@/components/processes/Process'

export default {
  components: {
    Process
  },
  computed: {
    ...mapGetters({
      account: 'account/account',
      processes: 'processes/processes'
    })
  },
  watch: {
    account () {
      if (this.account.id) {
        this.$echo.channel(`processes:${this.account.id}`).listen('ProcessStarted', (e) => {
          this.$store.commit('processes/PUSH', { key: e.key, state: e.state })
        })

        this.$echo.channel(`processes:${this.account.id}`).listen('ProcessStopped', (e) => {
          setTimeout(() => {
            this.$store.commit('processes/REMOVE', e.key)
          }, 3000)
        })
      }
    }
  }
}
</script>
